import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme, alpha } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StorefrontIcon from "@mui/icons-material/Storefront";
import BusinessIcon from "@mui/icons-material/Business";
import { StepContainer, ChecklistItem } from "../styles";
import { stepContent } from "../content";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.4 },
  },
};

const WelcomeStep = () => {
  const theme = useTheme();
  const content = stepContent.welcome;

  return (
    <StepContainer>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Hero Section */}
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <StorefrontIcon
              sx={{
                fontSize: 64,
                color: theme.palette.primary.main,
                mb: 2,
                filter: `drop-shadow(0 4px 12px ${alpha(
                  theme.palette.primary.main,
                  0.3
                )})`,
              }}
            />
          </motion.div>

          <Typography variant="h4" fontWeight={700} gutterBottom>
            {content.title}
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            fontWeight={500}
            gutterBottom
          >
            {content.subtitle}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            {content.description}
          </Typography>
        </Box>

        {/* Completed Setup Checklist */}
        <Stack spacing={2} sx={{ maxWidth: 600, mx: "auto" }}>
          <motion.div variants={itemVariants}>
            <ChecklistItem completed={true}>
              <CheckCircleIcon
                sx={{ color: "success.main", fontSize: 32, mr: 2 }}
              />
              <Box flex={1}>
                <Typography variant="body1" fontWeight={600}>
                  Central de Entrega Configurada
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Endereço, contato e dados essenciais
                </Typography>
              </Box>
            </ChecklistItem>
          </motion.div>

          <motion.div variants={itemVariants}>
            <ChecklistItem completed={true}>
              <CheckCircleIcon
                sx={{ color: "success.main", fontSize: 32, mr: 2 }}
              />
              <Box flex={1}>
                <Typography variant="body1" fontWeight={600}>
                  Loja Cadastrada
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Seu estabelecimento está pronto
                </Typography>
              </Box>
            </ChecklistItem>
          </motion.div>

          <motion.div variants={itemVariants}>
            <Box
              sx={{
                mt: 3,
                p: 2,
                borderRadius: 2,
                bgcolor: alpha(theme.palette.info.main, 0.1),
                border: `1px solid ${alpha(theme.palette.info.main, 0.3)}`,
              }}
            >
              <Typography
                variant="body2"
                color="info.main"
                fontWeight={500}
                textAlign="center"
              >
                ✨ Vamos configurar recursos adicionais que vão otimizar sua
                operação
              </Typography>
            </Box>
          </motion.div>
        </Stack>
      </motion.div>
    </StepContainer>
  );
};

export default WelcomeStep;
